import React, { useEffect, useState } from 'react'
import { IoArrowBack, IoPersonCircleSharp } from 'react-icons/io5'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { links } from '../../constants/ProfillingConstants'
import CheckPermission from '../../hooks/useCheckPermission'
import { useTranslation } from 'react-i18next'
import LangSwitcher from './LangSwitcher'
import { Sidebar } from 'primereact/sidebar'
import { CalculateAge } from '../../utils/CalculateAge'
import { FaFemale, FaMale } from 'react-icons/fa'

function PatientProfilingLayout ({ children }) {
  const { t } = useTranslation()
  const [openMobileSidebar, setOpenMobileSidebar] = useState(false)
  const location = useLocation()
  const isEmr = [
    '/patient-profile/edit-emr',
    '/patient-profile/create-emr'
  ].some(path => location?.pathname?.includes(path))
  return (
    <div className='flex h-[100vh] relative'>
      <div className='absolute right-5 top-5'>
        <i
          className='text-dark !text-[20px] block cursor-pointer sm:hidden me-3 pi pi-bars'
          onClick={() => setOpenMobileSidebar(true)}
        />
      </div>

      <div>
        <div className='bg-primary h-full hidden sm:block md:w-[180px] lg:w-[200px] min-h-screen relative xl:w-[220px]'>
          <PatientProfileSidebarContent
            isEmr={isEmr}
            setOpenMobileSidebar={setOpenMobileSidebar}
          />
        </div>

        <MobileSidebar
          openMobileSidebar={openMobileSidebar}
          setOpenMobileSidebar={setOpenMobileSidebar}
          title={t('RequestEligibility')}
        >
          <PatientProfileSidebarContent
            isEmr={isEmr}
            setOpenMobileSidebar={setOpenMobileSidebar}
          />
        </MobileSidebar>
      </div>
      <div className='bg-white h-[100vh] rounded-md w-full overflow-hidden'>
        {children}
      </div>
    </div>
  )
}

const MobileSidebar = ({
  children,
  openMobileSidebar,
  setOpenMobileSidebar
}) => {
  return (
    <Sidebar
      visible={openMobileSidebar}
      // header={customHeader}
      onHide={() => setOpenMobileSidebar(false)}
      pt={{
        root: { className: 'w-full rounded !bg-darkBg' },
        header: {
          className: 'flex items-center justify-end border-b border-gray-800'
        },
        content: { className: 'px-0' },
        closebutton: { className: '!text-red-500 !bg-gray-100' }
      }}
    >
      {children}
    </Sidebar>
  )
}

const PatientProfileSidebarContent = ({ isEmr, setOpenMobileSidebar }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { can } = CheckPermission()
  const location = useLocation()
  const locData = location?.state?.labData
  const selectedPatientData =
    useSelector(state => state?.auth?.seletedPatientData?.labData) || locData

  useEffect(() => {
    if (
      selectedPatientData?.patient_id ===
      JSON.parse(localStorage.getItem('emrFormData'))?.selected_patient_id
    ) {
    } else {
      localStorage.removeItem('emrFormData')
    }
  }, [])

  const { t } = useTranslation()
  return (
    <div className='flex flex-col h-screen overflow-hidden'>
      <div className='flex flex-col border-b border-white items-center pt-4 pb-4 shrink-0'>
        <div className='flex items-center justify-center pb-2'>
          <LangSwitcher />
        </div>
        <div className='relative'>
          <IoArrowBack
            size={25}
            className='text-white absolute right-[50px] top-[8px]  cursor-pointer'
            onClick={() => {
              navigate('/dashboard')
            }}
          />
          <span
            className={`flex items-center justify-center w-12 h-12 rounded-full shadow-sm
             ${
               selectedPatientData?.gender === 'female'
                 ? 'bg-rose-100 text-rose-600'
                 : selectedPatientData?.gender === 'male'
                 ? 'bg-sky-100 text-sky-600'
                 : null
             }`}
          >
            {selectedPatientData?.gender === 'female' ? (
              <FaFemale size={28} />
            ) : selectedPatientData?.gender === 'male' ? (
              <FaMale size={28} />
            ) : null}
          </span>
          {/* <IoPersonCircleSharp size={40} className="text-white" /> */}
        </div>
        <h1 className='text-16-gray text-center !font-[500] !text-white mt-4 px-2'>
          {selectedPatientData?.full_name || 'N/A'}
        </h1>
        <div className=' w-full py-4'>
          <div className='flex gap-2 items-start px-2 py-1'>
            <h3 className='text-[14px] text-white font-[500] w-[78px] shrink-0 leading-5'>
              {t('File')} :
            </h3>
            <p className='text-[14px] text-white font-[400] leading-5 break-words min-w-0'>
              {selectedPatientData?.file_no || 'N/A'}
            </p>
          </div>
          <div className='flex gap-2 items-start px-2 py-1'>
            <h3 className='text-[14px] text-white font-[500] w-[78px] shrink-0 leading-5'>
              {t('DID')} :
            </h3>
            <p className='text-[14px] text-white font-[400] leading-5 break-words min-w-0'>
              {selectedPatientData?.document_id || 'N/A'}
            </p>
          </div>
          <div className='flex gap-2 items-start px-2 py-1'>
            <h3 className='text-[14px] text-white font-[500] w-[78px] shrink-0 leading-5'>
              {t('Type')} :
            </h3>
            <p className='text-[14px] text-white font-[400] leading-5 break-words min-w-0'>
              {selectedPatientData?.beneficiary_type || 'N/A'}
            </p>
          </div>
          <div className='flex gap-2 items-start px-2 py-1'>
            <h3 className='text-[14px] text-white font-[500] w-[78px] shrink-0 leading-5'>
              {t('Mobile')} :
            </h3>
            <p className='text-[14px] text-white font-[400] leading-5 break-words min-w-0'>
              {selectedPatientData?.contact || 'N/A'}
            </p>
          </div>
          <div className='flex gap-2 items-start px-2 py-1'>
            <h3 className='text-[14px] text-white font-[500] w-[78px] shrink-0 leading-5'>
              {t('Age')} :
            </h3>
            <p className='text-[14px] text-white font-[400] leading-5 break-words min-w-0'>
              {CalculateAge(selectedPatientData?.dob) || 'N/A'}
            </p>
          </div>
          <div className='flex gap-2 items-start px-2 py-1'>
            <h3 className='text-[14px] text-white font-[500] w-[78px] shrink-0 leading-5'>
              {t('Payer')} :
            </h3>
            <p className='text-[14px] text-white font-[400] leading-5 break-words min-w-0'>
              {selectedPatientData?.insurance_plans?.filter(
                item => item?.is_primary === true
              )?.[0]?.payer_name ||
                selectedPatientData?.insurance_plans?.[0]?.payer_name ||
                selectedPatientData?.selected_plan?.payer_name ||
                'N/A'}
            </p>
          </div>
          <div className='flex gap-2 items-start px-2 py-1'>
            <h3 className='text-[14px] text-white font-[500] w-[78px] shrink-0 leading-5'>
              {t('Policy #')} :
            </h3>
            <p className='text-[14px] text-white font-[400] leading-5 break-words min-w-0'>
              {selectedPatientData?.insurance_plans?.filter(
                item => item?.is_primary === true
              )?.[0]?.policy_number ||
                selectedPatientData?.insurance_plans?.[0]?.policy_number ||
                selectedPatientData?.selected_plan?.policy_number ||
                'N/A'}
            </p>
          </div>
          <div className='flex gap-2 items-start px-2 py-1'>
            <h3 className='text-[14px] text-white font-[500] w-[78px] shrink-0 leading-5'>
              {t('Class')} :
            </h3>
            <p className='text-[14px] text-white font-[400] leading-5 break-words min-w-0'>
              {selectedPatientData?.insurance_plans?.filter(
                item => item?.is_primary === true
              )?.[0]?.class_name ||
                selectedPatientData?.insurance_plans?.[0]?.class_name ||
                selectedPatientData?.selected_plan?.class_name ||
                'N/A'}
            </p>
          </div>
        </div>
      </div>
      <div className='flex flex-col flex-1 overflow-y-auto mt-4'>
        {links(t)?.map(
          (data, index) =>
            can(data?.moduleName, data?.permission) && (
              <NavLink
                onClick={() => {
                  if (setOpenMobileSidebar) setOpenMobileSidebar(false)
                }}
                key={index}
                to={data?.link}
                target={isEmr ? '_blank' : '_self'}
                rel={isEmr ? 'noopener noreferrer' : ''}
                className={`w-full cursor-pointer text-white flex flex-row gap-3 items-center py-3 ps-3 pe-1  group transition-all duration-300 sidebar-navlink`}
              >
                <div className='flex bg-primary h-[25px] border border-white justify-center rounded-full w-[25px] group-hover:bg-white group-hover:text-primary items-center'>
                  {data?.icon}
                </div>
                <p className='text-[14px] text-white font-[400] '>
                  {data?.label}
                </p>
              </NavLink>
            )
        )}
      </div>
    </div>
  )
}

export default PatientProfilingLayout
